import React from 'react';
import api from '../api';
import { 
    createMuiTheme, 
    makeStyles, 
    MuiThemeProvider, 
    Paper, 
    Typography, 
    withStyles, 
    Tooltip, 
    Snackbar,
 } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Loader from 'react-loader-spinner'
import { useHistory, useLocation } from 'react-router-dom';
import ic_detail from '../../assets/ic_detail.png';
import ic_search from '../../assets/ic_search.png';
import MuiAlert from '@material-ui/lab/Alert';
import SearchComponent from '../components/search/SearchComponent'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

export default function JadwalFasilitas(props) {
    const history = useHistory()
    const location = useLocation()
    console.log(location);
    const classes = useStyles()
    const [jadwal, setJadwal] = React.useState(location.state !== undefined ? location.state.data.detailSchedule : []);
    const [name, setName] = React.useState(location.state !== undefined ? location.state.data.detailSchedule.name : "");
    const [list, setList] = React.useState([])
    const [value, setValue] = React.useState(location.state !== undefined ? location.state.data.detailSchedule : [])
    const [detailSchedule, setDetailSchedule] = React.useState(location.state !== undefined ? location.state.data.detailSchedule : [])
    const [loading, setLoading] = React.useState(false)
    const [visibleSearch, setVisibleSearch] = React.useState(false)
    const [searchName, setSearchName] = React.useState(null)
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);

    console.log(detailSchedule);
    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        console.log(jadwal);
        history.push({
            pathname: '/schedule/detail-jadwal-fasilitas',
            name: 'Detail Master Jadwal Fasilitas',
            state: {
                efDate: rowData[1],
                sentData: jadwal,
                value,
                detailSchedule
            }
        })
    }

    const columns = [
        {
            name: "no",
            label: "No",
            options: {
                sort: true,
                sortThirdClickReset: true,

            }
        },
        {
            name: "date",
            label: "Tanggal Berlaku",
            options: {
                sort: true,
                sortThirdClickReset: true,

            }
        },
        // {
        //     name: "time_end",
        //     label: "Waktu Selesai Periksa"
        // }, 
        {
            name: "Aksi",
            options: {
                search: false,
                filter: false,
                sort: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            {update && (
                                <LightTooltip title={"Detail"} arrow>
                                    <button
                                        onClick={() => handleSeeDetail(tableMeta)}
                                        style={{
                                            backgroundColor: "transparent",
                                            fontSize: 20,
                                            outline: 'none',
                                            borderColor: 'transparent'
                                        }}>
                                        <img src={ic_detail} style={{ width: 30, height: 30 }} />
                                    </button>
                                </LightTooltip>
                            )}
                        </div>
                    )
                }
            }
        }];


    React.useEffect(() => {
        props.setShowNotif(true)
        getFacility()
        // getSchedule()
        getPermission(props)
        setLoading(true)
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getFacility = () => {
        api.create().getAllFacility().then(response => {
            console.log(response)
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        let data = []
                        if (response.data.data.length > 0) {
                            response.data.data.map((item) => {
                                if (item.status === 1) {
                                    data.push(item)
                                }
                            })
                        }
                        setList(data)
                        setLoading(false)
                    }
                }
            }
        })
    }

    const getSchedule = (el) => {
        api.create().getMasterSchedule(el.id).then(response => {
            console.log(response)
            // let temp = []
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data != false) {
                        response.data.data[0].effective_date.map((el, idx) => {
                            console.log(el);
                            el["no"] = idx + 1
                            // el.effective_date.map((item, idx) => {
                            //     item["no"] = idx + 1
                            // })
                            // console.log(el);
                            // temp.push(el)
                        })
                        setJadwal(response.data.data[0])
                        setDetailSchedule(response.data.data[0])
                        setValue(response.data.data[0].effective_date)
                        // setList(temp)
                        // setLoading(false)
                    } else {
                        setJadwal(el)
                    }
                }
            }
            // setJadwal(temp)
            // setDetailSchedule(temp)
        })
    }

    const handleClick = (el) => {
        console.log(el);
        setName(el.name)
        const id = el
        getSchedule(id)
        // getDetailSchedule(el)
        // setJadwal(el)
        // setDetailSchedule(el)
        // setValue(el.effective_date)
    }

    const handleChange = (e) => {
        console.log(e);
        setValue(e)
    }

    const handleCron = () => {
        api.create().createManualCronFasilitas().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.data)
                    setStatusAlert("success")
                } else {
                    setOpenAlert(true)
                    setMessageAlert(JSON.stringify(response.data.data))
                    setStatusAlert("warning")
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const handleSearch = (key) => {
        setLoading(true)
        if (key === null || key === "") {
            getFacility()
        } else {
            api.create().getAllFacilityFilter(key).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let data = []
                            response.data.data.map((item, index) => {
                                if (item.status === 1) {
                                    data.push(item)
                                }
                            })
                            setList(data)
                            setLoading(false)
                        } else {
                            setList([])
                            setLoading(false)
                        }
                    }
                }
            })
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            {/* {loading ? loadingComponent : null} */}
            <div style={{ paddingTop: 20, paddingLeft: 0, width: "24%", backgroundColor: 'transparent', marginTop: 10, borderRadius: 10, height: '87vh', overflow: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography style={{ color: '#278863' }}>List Fasilitas</Typography>
                    <div style={{ cursor: 'pointer', alignSelf: 'center' }}
                        onClick={() => {
                            handleCron()
                        }}>
                        <Typography style={{ color: '#0066ff', fontSize: 14 }}>Create Manual Cron</Typography>
                    </div>
                </div>
                <hr style={{ marginTop: 0 }} />
                {
                    !visibleSearch ?
                        <img title="Cari Fasilitas" onClick={() => setVisibleSearch(true)} src={ic_search} style={{ marginBottom: 10, cursor: 'pointer' }} />
                        :
                        <SearchComponent
                            placeholder={"Input Nama Fasilitas"}
                            onSearch={(val)=>{handleSearch(val)}}
                            onDelete={()=>{
                                handleSearch(null)
                                setVisibleSearch(false)
                                setSearchName("")
                            }}
                        /> 
                }
                {
                    list && list.map((el, idx) => {
                        return (
                            <div style={{ cursor: "pointer" }} onClick={() => handleClick(el)}>
                                <Typography style={{ fontSize: 14, padding: 3, color: jadwal.name === el.name || el.name === name ? '#278863' : '#b4b4b4', borderLeft: jadwal.name === el.name || el.name === name ? '3px solid green' : null, borderSpacing: jadwal.name === el.name || el.name === name ? "0, 0, 0, 370" : null, marginBottom: 10, fontWeight: 'normal' }}>{el.name}</Typography>
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ paddingTop: 20, width: "75%", marginTop: 36 }}>
                {read && (
                    <div>
                        {name != "" ?
                            <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', scrollBehavior: true }} >
                                {create && (
                                    <div style={{ padding: 20, position: 'absolute', top: 87, zIndex: 2 }}>
                                        {detailSchedule ?
                                            <button
                                                style={{ backgroundColor: 'transparent', border: 'transparent', borderColor: 'transparent', outline: 'none' }}
                                                onClick={() => history.push({
                                                    pathname: '/masterdata/tambah-jadwal-fasilitas',
                                                    name: 'Tambah Master Jadwal Fasilitas',
                                                    search: '?update=true',  // query string
                                                    state: {  // location state
                                                        data: jadwal,
                                                        value,
                                                        detailSchedule
                                                    },
                                                })}
                                            >
                                                <div style={{ display: 'flex', height: 30, width: 150, backgroundColor: '#2a9c6c', borderRadius: 70 }}>
                                                    <img style={{ margin: 'auto', width: 25, marginRight: 3 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                                    <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 10, color: 'white' }}>Tambah Jadwal</Typography>
                                                </div>
                                            </button>
                                            : null
                                        }

                                    </div>
                                )}
                                <div style={{ marginTop: -24 }}>
                                    {
                                        jadwal && jadwal.effective_date ?
                                            <MuiThemeProvider theme={getMuiTheme()}>
                                                <MUIDataTable
                                                    data={detailSchedule.effective_date}
                                                    columns={columns}
                                                    options={options}
                                                />
                                            </MuiThemeProvider>
                                            :
                                            <div style={{ width: '100%', height: '280px', margin: 'auto', justifyContent: 'center', textAlign: 'center', paddingTop: 50 }} >
                                                <h1 style={{ margin: 'auto', marginTop: 50 }}>Jadwal Belum Ada</h1>
                                            </div>
                                    }
                                </div>
                            </Paper>
                            :
                            <Paper style={{ width: '100%', height: '380px', margin: 'auto', justifyContent: 'center', textAlign: 'center', borderRadius: 20, marginTop: 0, boxShadow: '5px 5px 10px 0 #999999', paddingTop: 50 }} >
                                <h1 style={{ margin: 'auto', marginTop: 50 }}>Silahkan pilih Fasilitas</h1>
                            </Paper>
                        }
                    </div>
                )}
                {/* {visibleDetail ?
                    <EditJadwal
                        onClose={onClose}
                        detail={poliDokter.polyclinic}
                        efDate={selectDate}
                    />
                    : null
                } */}
            </div>
        </div>
    )
}